<template>
  <div :class="'col-md-' + col" class="textarea">
    <label>{{ label }} <span v-if="isRequired">*</span></label>
    <div class="textarea-content">
      <textarea :name="name" v-model="contentTextarea" :placeholder="placeholder" max-length="2000"/>
    </div>
    <span class="textarea-error" v-if="inputError">Preencha o campo *</span>
  </div>
</template>

<script>
export default {
  name: "inputTextarea",
  props: {
    label: {
      required: true,
    },
    placeholder: {
      required: true,
    },
    isRequired: {
      default: false,
    },
    col: {
      required: true,
    },
    inputError: {
      default: false,
    },
    name: {
      default: ''
    }
  },
  data() {
    return {
      contentTextarea: ''
    }
  },
  watch: {
    contentTextarea(newValue, oldValue) {
      this.$emit('contentTextarea', newValue)
    }
  }
}
</script>

<style lang="scss" scoped>

.textarea {
  position: relative;
  margin-bottom: 20px;

  label {
    font-size: 14px;
    font-weight: 400;
    color: #191919;
    margin-bottom: 4px;

    span {
      font-weight: 400;
      font-size: 14px;
      color: #FF445D;
    }
  }

  &-content {
    textarea {
      max-width: 100%;
      min-width: 100%;
      min-height: 100px;
      max-height: 300px;
      background: #EEF2F7;
      border-radius: 4px !important;
      padding: 6px 12px;
      border: 1px solid #EEF2F7;
      transition: .2s;
      font-size: 16px;
      font-weight: 400;
      color: #3A424E;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;

      &::placeholder {
        font-size: 16px;
        font-weight: 400;
        color: #7E8DA7;
      }

      &:hover {
        transition: .2s;
        border: 1px solid #cacaca;
      }

      &:focus-visible {
        outline: none;
        transition: .2s;
        border: 1px solid #cacaca;

        &::placeholder {
          transition: .1s;
          color: #EEF2F7;
        }
      }
    }
  }

  &-error {
    position: absolute;
    left: 15px;
    bottom: -15px;
    font-size: 11px;
    color: #D9534F;
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/components/inputs/inputTextarea.vue